import classNames from "classnames";
import SearchResultItem from "./SearchResultItem";
import style from "./EnhancedSearchResults.module.scss";
import DrugIndicationIndex from "./DrugIndicationIndex";

const SearchResultsList = ({
  searchResults,
  selectedTab,
  searchTerm,
  drugSummary,
  isAppMode = false,
  isWebModernisationEnabled = false,
  noResultsMessage = "results",
  resultCount,
}) => {
  const results = searchResults[selectedTab]?.results ?? [];
  if (results.length === 0) {
    return (
      <div className={classNames("size-18", style.noResultsText)}>
        {`No ${noResultsMessage} found.`}
      </div>
    );
  }

  return (
    <div className="search-results-list">
      <div className={classNames("size-16", style.resultCountText)}>
        <span>{resultCount} results</span>
      </div>
      {isWebModernisationEnabled && selectedTab === 1 && drugSummary.length > 0 && (
        <DrugIndicationIndex isAppMode={isAppMode} drugs={drugSummary} drugCount={resultCount} />
      )}

      {results.map((result, index) => (
        <SearchResultItem
          selectedTab={selectedTab}
          key={index}
          searchTerm={searchTerm}
          searchResult={result}
          isAppMode={isAppMode}
          isWebModernisationEnabled={isWebModernisationEnabled}
        />
      ))}
    </div>
  );
};

export default SearchResultsList;
